import React from 'react'
import { Icon } from 'antd'

const ModeCard = ({ icon, title, description, selected, onClick, color }) => {
  return (
    <div
      className={`mode-card ${selected ? 'mode-card--selected' : ''}`}
      onClick={onClick}
      style={{
        '--card-color': color,
        '--card-color-light': `${color}15`,
        '--card-color-border': selected ? color : 'transparent'
      }}
    >
      <div className="mode-card__check">
        {selected && <Icon type="check-circle" theme="filled" />}
      </div>

      <div className="mode-card__icon">
        <Icon type={icon} />
      </div>

      <div className="mode-card__content">
        <h3 className="mode-card__title">{title}</h3>
        <p className="mode-card__description">{description}</p>
      </div>
    </div>
  )
}

export default ModeCard
